module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rating"
  }, [_c('h1', [_vm._v("Tidigare provade öl")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-73756cb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListBeers.vue
// module id = 27
// module chunks = 0